import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { formatDurationClock } from 'helpers/date_utils';
import { clickAsLink } from 'helpers/link_helpers';
import { valueOrPlaceholder } from 'helpers/string_helpers';
import { valueOrZero } from 'helpers/number_helpers';
import { Col, Row } from 'react-bootstrap-5';

class PreviewHeader extends React.Component {
  static propTypes = {
    callDuration: PropTypes.number,
    callList: PropTypes.shape({
      incompleteCalls: PropTypes.number,
      name: PropTypes.string
    }),
    callListId: PropTypes.number,
    isCalling: PropTypes.bool,
    record: PropTypes.shape({
      name: PropTypes.string
    }).isRequired,
    validNextTask: PropTypes.bool,
    validPrevTask: PropTypes.bool,
    onNextRecord: PropTypes.func,
    onPrevRecord: PropTypes.func
  }

  handleGoToCallList = (e) => {
    clickAsLink(window, '/contacts/call_lists', e);
  }

  recordName = () => {
    const { isCalling, record } = this.props;
    const name = valueOrPlaceholder(record.name);

    if (isCalling) {
      return (
        <div className="title slim">
          <b>Connected to: </b>
          <span className="record-name">{name}</span>
        </div>
      );
    }

    return (
      <b className="text-nowrap">{name}</b>
    );
  }

  callListLabel = () => {
    const { callList } = this.props;

    const remainingCalls = valueOrZero(callList.incompleteCalls);

    const remainingText = remainingCalls === 1
      ? `${remainingCalls} Call` : `${remainingCalls} Calls`;

    return (
      <small className="subtitle record-call-list" name="call-list-label">
        <span className="clickable call-list-title" onClick={this.handleGoToCallList}>
          {`${callList.name} Call List`}
        </span>
        {` - ${remainingText} Remaining`}
      </small>
    );
  }

  callTimer = () => {
    const { callDuration, isCalling } = this.props;
    if (callDuration == null || !isCalling) return null;

    return (
      <div className="title slim call-timer" name="call-timer">
        {formatDurationClock(callDuration)}
      </div>
    );
  }

  pagination = () => {
    const {
      callListId,
      isCalling,
      validNextTask,
      validPrevTask,
      onNextRecord,
      onPrevRecord
    } = this.props;

    if (!callListId || isCalling) return null;

    let prevButton, nextButton;

    if (validPrevTask) {
      prevButton = <b className="clickable" name="previous-button" onClick={onPrevRecord}>&lt; Prev</b>;
    } else {
      prevButton = <b className="text-muted" name="previous-button">&lt; Prev</b>;
    }

    if (validNextTask) {
      nextButton = <b className="clickable" name="next-button" onClick={onNextRecord}>Next &gt;</b>;
    } else {
      nextButton = <b className="text-muted" name="next-button">Next &gt;</b>;
    }

    return (
      <div className="title slim call-timer">
        {prevButton}
        <span className="mx-2">|</span>
        {nextButton}
      </div>
    );
  }

  render() {
    const { callList, callListId, isCalling } = this.props;

    const headerClassNames = classNames({
      'preview-overlay-content-header': true,
      'navbar': true,
      'is-active': isCalling,
      'pt-3': !callListId
    });

    return (
      <div className={headerClassNames}>
        <Row className="text-white">
          <Col xs={8}>
            {this.recordName()}
            {(callList && callList.tasks && callListId) ? this.callListLabel() : null}
          </Col>
          <Col xs={4}>
            {this.callTimer()}
            {this.pagination()}
          </Col>
        </Row>
      </div>
    );
  }
}

export default PreviewHeader;
